import React from 'react';

const WarningCard = () => {
  return (
    <div className="mb-4 flex items-start gap-3 rounded-lg border border-yellow-200 bg-yellow-50/80 p-4 text-yellow-800 shadow-sm">
      {/* Warning Icon */}
      <svg
        className="mt-0.5 h-5 w-5 flex-shrink-0"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      {/* Message */}
      <div>
        <p className="text-sm font-medium">
          You need to be logged in to request an appointment.
        </p>
        <p className="text-sm">
          Please{' '}
          <a
            href="/login?redirect=/appointment"
            className="underline hover:text-yellow-900"
          >
            log in
          </a>{' '}
          or{' '}
          <a href="/register" className="underline hover:text-yellow-900">
            create an account
          </a>{' '}
          to continue.
        </p>
      </div>
    </div>
  );
};

export default WarningCard;
